/* eslint-disable jsx-a11y/interactive-supports-focus */
import { SCRIBE_REGULATION_EVENTS } from 'applications/scribe/instrumentations/track';
import ScribeDuck from 'ducks/scribe-duck';
import { Alert } from 'grab-ui';
import PropTypes from 'prop-types';
import rightArrow from 'public/icons/right-arrow.svg';
import warningIcon from 'public/icons/warning-yellow.svg';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { getLocalizedTitle } from '../banner-utils';
import styles from '../styles.less';

// https://experiments.stg-myteksi.com/t/variables/expressPaxHomeV2AnnouncementBanner/rollout
const PaxHomeBanner = ({ banner }) => {
  const dispatch = useDispatch();
  const titleOrMessage = banner.message || banner.title;
  const title = getLocalizedTitle(titleOrMessage);

  useEffect(
    () => {
      if (title) {
        dispatch(
          ScribeDuck.creators.scribeEVRegulationEvent({
            eventName: SCRIBE_REGULATION_EVENTS.EV_REGULATION_BANNER_VIEW,
            title,
          }),
        );
      }
    },
    [title, dispatch],
  );

  if (!title) {
    return null;
  }

  return (
    <div className={styles.container}>
      <Alert
        type={'warning'}
        className={styles.alert}
        message={
          <div className={styles.message}>
            {title}
            {banner.url && (
              <button
                className={styles.actionIconButton}
                onClick={() => {
                  window.open(banner.url, '_blank');
                }}
                aria-label="understand-more"
              >
                <img src={rightArrow} className={styles.actionIcon} alt="" />
              </button>
            )}
          </div>
        }
        icon={
          <img
            src={banner.icon || warningIcon}
            alt="warning"
            className={styles.bannerIcon}
          />
        }
        closable={false}
        showIcon
      />
    </div>
  );
};

PaxHomeBanner.defaultProps = {
  banner: {
    title: '',
    icon: '',
    url: '',
    displayIn: [],
    from: '',
    to: '',
  },
};

PaxHomeBanner.propTypes = {
  banner: PropTypes.shape({
    title: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.object, // For i18n: {en: "...", vi: "..."}
    ]),
    message: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.object, // For i18n: {en: "...", vi: "..."}
    ]),
    icon: PropTypes.string,
    url: PropTypes.string,
    displayIn: PropTypes.arrayOf(PropTypes.string),
    from: PropTypes.string,
    to: PropTypes.string,
  }),
};

export default withRouter(PaxHomeBanner);
